import { inject, Service } from '@angular/core';
import { RouteBuilderService } from '@core/providers/backend/route-builder.service';
import { CONSTANTS } from '@shared/constants';
import { SidebarMenu } from '@shared/interfaces/sidebar/sidebar-menu.interface';

@Service()
export class SidebarService {
  private routeBuilderService = inject(RouteBuilderService);

  /**
   * Resolves each menu entry's route against the current context and drops the entries a
   * non-elevated user may not reach. Filtering applies at this level only — nested submenus are
   * resolved but not re-filtered, which is how the nav has always been built.
   */
  setSidebarsURLS(
    sidebarMenus: SidebarMenu[] | null,
    isAccountContext: boolean,
    uuid: string,
    isElevatedUser: boolean = true
  ): SidebarMenu[] {
    if (!sidebarMenus || !sidebarMenus.length) {
      return [];
    }

    return sidebarMenus
      .map((sidebarMenu: SidebarMenu) => {
        // A divider grants no access of its own, so dropping it for a regular user would take
        // the grouping with it and leave the pop-out and the landing page one undivided run.
        if (!isElevatedUser && !sidebarMenu.isRegularUserAccess && !sidebarMenu.isDivider) {
          return null;
        }
        const cloned: SidebarMenu = { ...sidebarMenu };
        if (cloned.submenu && cloned.submenu.length) {
          cloned.submenu = this.setSidebarsURLS(cloned.submenu, isAccountContext, uuid);
        } else {
          cloned.link = this.getSubmenuURL(isAccountContext, cloned, uuid);
        }
        return cloned;
      })
      .filter(sidebar => !!sidebar);
  }

  private getSubmenuURL(isAccountContext: boolean, submenu: SidebarMenu, uuid: string): string {
    if (!submenu || !submenu.link) {
      return '';
    }
    const URLParam: string = isAccountContext
      ? CONSTANTS.ROUTE_PARAMS.ACCOUNT_ID
      : CONSTANTS.ROUTE_PARAMS.VENUE_ID;
    try {
      return this.routeBuilderService.getAbsoluteRoute(submenu.link, {
        [URLParam]: uuid,
      });
    } catch {
      return submenu.link;
    }
  }
}
